import { Swiper, Navigation } from "swiper/js/swiper.esm.js";

export default class LegCountyFactsSlider {
  constructor(factsSlider) {
    Swiper.use([Navigation]);

    let sliderContainer = factsSlider.parentElement;
    let prevButton = sliderContainer.querySelector(".swiper-button-prev");
    let nextButton = sliderContainer.querySelector(".swiper-button-next");

    var mySwiper = new Swiper(factsSlider, {
      // Optional parameters

      speed: 1000,
      grabCursor: true,
      autoHeight: true,

      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },

        768: {
          slidesPerView: 3,
          spaceBetween: 40,
          grabCursor: false,
        },
      },
    });
  }
}
